import type React from "react";
import type { FC } from "react";
import type { ExpenseStructured, OurWorkStructured } from "../../models";
import { BudgetItem } from "./BudgetItem";

interface Props {
  structured: OurWorkStructured | ExpenseStructured;
}

export const StructuredBudgetItem: FC<React.PropsWithChildren<Props>> = ({
  structured,
}) => {
  const { budgetItemsWithSplit: budgetItemsWithAmount } = structured;
  return (
    <div className="py-8">
      <h2 className="text-xl text-gray-600 font-semibold uppercase">
        {structured.name}
      </h2>
      {(budgetItemsWithAmount as any[]).map(([budgetItem, split]) => (
        <BudgetItem
          key={budgetItem.id}
          item={budgetItem}
          amount={split.amount}
        />
      ))}
    </div>
  );
};
